"use strict";

exports.__esModule = true;
exports.DataItemChartV2Element = DataItemChartV2Element;
var _react = _interopRequireWildcard(require("react"));
var _Catalogs = require("../../../Catalogs");
var _featureFlags = require("../../../featureFlags");
var _Utils = require("../../../Utils");
var _timeFormatters = require("../../../Utils/timeFormatters");
var _constants = require("../../constants");
var _Device = require("../../Device");
var _downloadDataFromSeries = require("../../Echarts/Series/downloadDataFromSeries");
var _Feature = _interopRequireDefault(require("../../FeatureFlags/Feature/Feature"));
var _useFeature = _interopRequireDefault(require("../../FeatureFlags/Hooks/useFeature"));
var _Time = require("../../Time");
var _DataItemPopover = require("../common/DataItemPopover/DataItemPopover");
var _TargetPopover = require("../common/TargetPopover/TargetPopover");
var _styles = require("../DataItemChart/styles");
var _dataConverter = require("./dataConverter");
var _HistoricalDataItemChartV2Element = require("./HistoricalDataItemChartV2Element");
var _RealTimeDataItemChartV2Element = require("./RealTimeDataItemChartV2Element");
var _widget = require("./widget");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Displays data item chart v2 element widget.
 */
function DataItemChartV2Element(props) {
  var _useContext = (0, _react.useContext)(_Time.TimeContext),
    timezone = _useContext.timezone,
    currentWorkday = _useContext.currentWorkday,
    currentShift = _useContext.currentShift;
  var saveFlag = (0, _useFeature["default"])(_featureFlags.ENABLE_DATA_ITEM_SAVE);
  var device = (0, _react.useContext)(_Device.DeviceContext);
  var timePeriod = (0, _Time.useSelectionContext)();
  var width = props.width,
    height = props.height,
    title = props.title,
    toolbox = props.toolbox,
    statistics = props.statistics,
    visualMap = props.visualMap,
    chartItems = props.chartItems,
    controls = props.controls,
    dataItemSource = props.dataItemSource,
    realtimeItems = props.realtimeItems,
    historicalItems = props.historicalItems,
    dataItems = props.dataItems,
    updateLayout = props.updateLayout;
  var options = {
    title: title,
    toolbox: toolbox,
    statistics: statistics,
    visualMap: visualMap,
    chartItems: chartItems,
    controls: controls
  };
  var _useState = (0, _react.useState)(false),
    dataPopoverOpen = _useState[0],
    setDataPopoverOpenState = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    targetPopoverOpen = _useState2[0],
    setTargetPopoverOpen = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    dataItemsToShow = _useState3[0],
    setDataItemsToShow = _useState3[1];
  var _useState4 = (0, _react.useState)(false),
    itemChangedInPopover = _useState4[0],
    setItemChangedInPopover = _useState4[1];
  var _useState5 = (0, _react.useState)(undefined),
    targetValue = _useState5[0],
    setTargetValue = _useState5[1];
  (0, _react.useEffect)(function () {
    if (!itemChangedInPopover && dataItemSource && device) {
      var items = (0, _dataConverter.getDataItemsForProvidedSource)(device, dataItemSource, realtimeItems, historicalItems, dataItems);
      setDataItemsToShow(items || []);
    }
  }, [device, dataItemSource, realtimeItems, historicalItems, dataItems, itemChangedInPopover]);
  var isCurrent = dataItemSource == _widget.REALTIME_ITEMS && (0, _Catalogs.canSubscribeToRealtime)(currentWorkday.interval, currentShift.interval, timePeriod.interval);
  var ChartComponent = isCurrent ? _RealTimeDataItemChartV2Element.RealTimeDataItemChartV2Element : _HistoricalDataItemChartV2Element.HistoricalDataItemChartV2Element;
  var _useState6 = (0, _react.useState)(width),
    widthForBin = _useState6[0],
    setWidthForBin = _useState6[1];
  var debounceToSetWidth = (0, _react.useCallback)((0, _Utils.debounce)(function (width) {
    setWidthForBin(width);
  }), []);
  (0, _react.useEffect)(function () {
    debounceToSetWidth(width);
  }, [width]);
  var downloadDataItemData = function downloadDataItemData(deviceName, data) {
    return (0, _downloadDataFromSeries.downloadDataFromSeries)(deviceName + "-dataItems-" + (0, _timeFormatters.formatToDateOnly)(timePeriod.startPlantTime, timezone) + "-" + (0, _timeFormatters.formatToDateOnly)(timePeriod.endPlantTime, timezone), data, "Data item name");
  };
  var editPopover = function editPopover(dataItemSource) {
    return /*#__PURE__*/_react["default"].createElement(_Feature["default"], {
      name: _featureFlags.ENABLE_DATA_ITEM_EDIT
    }, /*#__PURE__*/_react["default"].createElement(_DataItemPopover.DataItemPopover, {
      dataItems: dataItemsToShow,
      isMultiSelector: true,
      allowedCategories: [_constants.CATEGORY_SAMPLE],
      onSubmit: function onSubmit(values) {
        var dataItemsToShow = (0, _dataConverter.convertDataItemsToEchartsDataItemFormat)(values, device);
        if (saveFlag) {
          updateLayout(props.path, "dataItems", dataItemsToShow);
        }
        setDataItemsToShow(dataItemsToShow);
        setItemChangedInPopover(true);
      },
      dataItemSource: dataItemSource,
      showButton: true,
      device: device,
      onOpen: function onOpen() {
        return setDataPopoverOpenState(true);
      },
      onClose: function onClose() {
        return setDataPopoverOpenState(false);
      },
      isOpen: dataPopoverOpen,
      enableAddingNewItem: false
    }));
  };
  var editTarget = function editTarget() {
    return /*#__PURE__*/_react["default"].createElement(_TargetPopover.TargetPopover, {
      targetValue: targetValue || 0,
      showButton: true,
      onSubmit: function onSubmit(targetValue) {
        return setTargetValue(targetValue);
      },
      onClose: function onClose() {
        return setTargetPopoverOpen(false);
      },
      onOpen: function onOpen() {
        return setTargetPopoverOpen(true);
      },
      isOpen: targetPopoverOpen
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.EditButtonsContainer, {
    toolboxEnabled: toolbox == null ? void 0 : toolbox.show
  }, editTarget(), editPopover(dataItemSource)), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "DataItemChartV2Element.element"
  }, /*#__PURE__*/_react["default"].createElement(ChartComponent, {
    dataItems: (0, _dataConverter.convertDataItemsToEchartsDataItemFormat)(dataItemsToShow, device),
    widthForBin: widthForBin,
    options: options,
    downloadDataItemData: downloadDataItemData,
    width: width,
    height: height,
    targetValue: targetValue
  })));
}